import React from 'react';
import { FashionWeekWorkspace } from './pages/FashionWeekWorkspace';
export function App() {
  return <FashionWeekWorkspace data-id="element-0" />;
}